import { useTranslation } from 'react-i18next';

export default function HowItWorksSection() {
  const { t } = useTranslation();

  const steps = [
    { num: '01', title: t('howItWorks.step1'), desc: t('howItWorks.step1Desc'), icon: 'ri-search-line' },
    { num: '02', title: t('howItWorks.step2'), desc: t('howItWorks.step2Desc'), icon: 'ri-exchange-line' },
    { num: '03', title: t('howItWorks.step3'), desc: t('howItWorks.step3Desc'), icon: 'ri-camera-line' },
    { num: '04', title: t('howItWorks.step4'), desc: t('howItWorks.step4Desc'), icon: 'ri-truck-line' },
    { num: '05', title: t('howItWorks.step5'), desc: t('howItWorks.step5Desc'), icon: 'ri-check-double-line' },
  ];

  return (
    <section className="section-padding bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            {t('howItWorks.title')}
          </h2>
        </div>

        <div className="relative">
          {/* Desktop connecting line */}
          <div className="hidden lg:block absolute top-16 left-[10%] right-[10%] h-0.5 bg-background-200"></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 md:gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative text-center">
                <div className="w-14 h-14 md:w-16 md:h-16 mx-auto flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-xl md:text-2xl font-bold mb-4 md:mb-5 relative z-10">
                  {step.num}
                </div>
                <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-primary-50 text-primary-600 mb-3">
                  <i className={`${step.icon} text-lg`}></i>
                </div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2">
                  {step.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {step.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}